import {FlexPage} from '@hconnect/common/components'
import {Grid, useMediaQuery, useTheme} from '@mui/material'

type LayoutProps = {
  navigationSlot?: React.ReactNode
  contentSlot?: React.ReactNode
  titleSlot?: React.ReactNode
  headerActionsSlot?: React.ReactNode
}

export const SlaTrackingLayout = ({
  navigationSlot,
  contentSlot,
  titleSlot,
  headerActionsSlot
}: LayoutProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const spacing = isMobile ? 1 : 2

  return (
    <FlexPage title={titleSlot} nameHeaderSx={{mt: 0}} headerActionContent={headerActionsSlot}>
      <Grid container spacing={spacing} flex={1}>
        <Grid item xs={12} sm={3}>
          {navigationSlot}
        </Grid>
        <Grid item container xs={12} sm={9}>
          {contentSlot}
        </Grid>
      </Grid>
    </FlexPage>
  )
}
